import { AfterViewInit, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { Data } from '../../helpers';
// import the WindowRef provider
import { WindowRef } from '../../windowHref';
import * as moment from 'moment';
//import { EmbedVideoService } from 'ngx-embed-video';
import { ConfirmationService } from 'primeng/primeng';
import { ErrorHandlerService } from '../../services';
import { DateTimeConverstionService } from '../../services/index';
import { EmbedVideoService } from 'ngx-embed-video';
var ViewcourseComponent = /** @class */ (function () {
    function ViewcourseComponent(/*private embedService: EmbedVideoService,*/ winRef, location, data, dashboardService, router, route, timeZoneConverstionService, confirmationService, errorHandlerService, embedService) {
        this.winRef = winRef;
        this.data = data;
        this.dashboardService = dashboardService;
        this.router = router;
        this.route = route;
        this.timeZoneConverstionService = timeZoneConverstionService;
        this.confirmationService = confirmationService;
        this.errorHandlerService = errorHandlerService;
        this.embedService = embedService;
        this.query = '';
        this.courseDetail = {};
        this.creator = {};
        this.startTime = {};
        this.endTime = {};
        this.url = '';
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.routeInd = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.schedual = { selectedDaysOfWeekStr: [] };
        this.video_html = "";
        this.daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        this.coursePreviewFbShareUrl = "";
        this.PR = window["PR"];
        this.copyText = "Copy Link";
        this.sessionSponsors = {
            Silver: [],
            Gold: [],
            Platinum: []
        };
        this.registerFromLogin = false;
        this.showSpinner = true;
        this.url = winRef.nativeWindow.location.href;
        console.log('window url =' + this.url);
        this.url = encodeURIComponent(this.url.replace('dashboard', 'public'));
        console.log('new replaced url =' + this.url);
        if (localStorage.getItem('regcourse')) {
            this.registerFromLogin = true;
            localStorage.removeItem('regcourse');
        }
        this.coursePreviewFbShareUrl = process.env.API_URL + "/generateFacebookPreviewForPublicCourse.do/";
    }
    ViewcourseComponent.prototype.copyUrl = function (url) {
        var _this = this;
        var selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = decodeURIComponent(url);
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        /* Alert the copied text */
        this.copyText = "Copied!!";
        setTimeout(function () {
            _this.copyText = "Copy Link";
        }, 5000);
    };
    ViewcourseComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    ViewcourseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.showSpinner = true;
        this.route.queryParams.subscribe(function (params) {
            _this.query = params['sessionId'] || 0;
            if (_this.query != '0') {
                _this.dashboardService.getCourse(_this.query).subscribe(function (data) {
                    _this.courseDetail = data;
                    if (data.sessionSponsors.length > 0) {
                        data.sessionSponsors.forEach(function (element) {
                            if (element.sponsorshipLevel == 'Silver') {
                                _this.sessionSponsors.Silver.push(element);
                            }
                            if (element.sponsorshipLevel == 'Gold') {
                                _this.sessionSponsors.Gold.push(element);
                            }
                            if (element.sponsorshipLevel == 'Platinum') {
                                _this.sessionSponsors.Platinum.push(element);
                            }
                        });
                    }
                    _this.coursePreviewFbShareUrl = _this.coursePreviewFbShareUrl + data.courseId;
                    +console.log("coursePreviewFbShareUrl==>" + _this.coursePreviewFbShareUrl);
                    if (data.url) {
                        _this.video_html = _this.embedService.embed(data.url);
                    }
                    console.log('cs');
                    console.log(_this.courseDetail);
                    if (_this.courseDetail.currentSchedule != undefined) {
                        _this.schedual = _this.courseDetail.currentSchedule;
                        if (_this.schedual.selectedDaysOfWeekStr != null) {
                            //this.schedual.selectedDaysOfWeekStr.sort(this.daysOfWeekSorter);
                            var that_1 = _this;
                            var sortDays = function (a, b) {
                                a = that_1.daysOfWeek.indexOf(a);
                                b = that_1.daysOfWeek.indexOf(b);
                                return a < b ? 0 : 1;
                            };
                            var myArrayOfDays = _this.schedual.selectedDaysOfWeekStr.sort(sortDays);
                        }
                    }
                    _this.creator = data.creator;
                    _this.startTime = data.startTime;
                    _this.endTime = data.endTime;
                    if (!_this.courseDetail.imageURL) {
                        _this.courseDetail.imageURL = "assets/images/worldmap.png";
                    }
                    if (localStorage.getItem('timezone')) {
                        _this.timezone = localStorage.getItem('timezone');
                    }
                    if (_this.timezone) {
                        _this.timeZonechange(_this.timezone);
                    }
                    _this.showSpinner = false;
                }, function (error) {
                    _this.showSpinner = false;
                    _this.handleError(error);
                });
            }
            else {
                _this.showSpinner = false;
            }
            //this.showSpinner = false;
        });
    };
    ViewcourseComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.registerFromLogin) {
            if (this.courseDetail.isRegistrationPossible) {
                setTimeout(function () {
                    if (_this.courseDetail.cost && !(_this.courseDetail.userRegistered == true || _this.courseDetail.owner == true)) {
                        if (_this.courseDetail.registrationQuestionnaireId != undefined && _this.courseDetail.registrationQuestionnaireId > 0) {
                            _this.showSpinner = true;
                            localStorage.setItem("isPaidSession", "true");
                            _this.router.navigate(['dashboard/questionnaire', _this.courseDetail.registrationQuestionnaireId]);
                        }
                        else {
                            _this.router.navigate(['dashboard/register'], { queryParams: { courseId: _this.query } });
                        }
                    }
                    else {
                        if (!(_this.courseDetail.userRegistered == true || _this.courseDetail.owner == true)) {
                            if (_this.courseDetail.registrationQuestionnaireId != undefined && _this.courseDetail.registrationQuestionnaireId > 0) {
                                _this.router.navigate(['dashboard/questionnaire', _this.courseDetail.registrationQuestionnaireId]);
                            }
                            else {
                                _this.freeRegister(_this.query);
                            }
                        }
                    }
                }, 1000);
            }
            else {
                this.registerFromLogin = false;
            }
        }
        else {
            this.registerFromLogin = false;
        }
    };
    ViewcourseComponent.prototype.timeZonechange = function (data) {
        this.courseDetail.displayStartDateOnlyConverted = this.timeZoneConverstionService.convertTimezone(data, 'date', this.courseDetail.courseStartDTime);
        this.courseDetail.timeZoneConverted = data;
        this.courseDetail.displayStopDateOnlyConverted = this.timeZoneConverstionService.convertTimezone(data, 'date', this.courseDetail.courseEndDTime);
        this.courseDetail.startTimeConverted = this.timeZoneConverstionService.convertTimezone(data, 'time', this.courseDetail.courseStartDTime);
        this.courseDetail.endTimeConverted = this.timeZoneConverstionService.convertTimezone(data, 'time', this.courseDetail.courseEndDTime);
        localStorage.setItem('timezone', data);
    };
    ViewcourseComponent.prototype.ngAfterViewChecked = function () {
        console.log('ngAfterViewChecked');
        this.PR.prettyPrint();
    };
    ViewcourseComponent.prototype.convertTimezone = function (timezone, type, datetime) {
        if (type == 'date') {
            var setdate = moment(datetime, 'YYYY-MM-DD HH:mm Z');
            return setdate.tz(timezone).format('MM/DD/YYYY');
        }
        else {
            var setdate = moment(datetime + '+00:00', 'HH:mmZ');
            return setdate.tz(timezone).format('HH:mm');
        }
    };
    ViewcourseComponent.prototype.navigateURL = function (url) {
        if (url.substring(0, 4) != 'http') {
            url = "//" + url;
        }
        window.open(url, "_blank");
    };
    ViewcourseComponent.prototype.navigateToQuestionnaire = function (type, qId) {
        if (type == "paid") {
            localStorage.setItem("isPaidSession", "true");
        }
        else {
            localStorage.removeItem("isPaidSession");
        }
        this.router.navigate(['../questionnaire', qId]);
    };
    ViewcourseComponent.prototype.freeRegister = function (id) {
        var _this = this;
        this.confirmationService.confirm({
            message: (this.registerFromLogin) ? "You are registering session <b>" + this.courseDetail.courseFullName + "</b>" + "<br><br>By registering you agree to Uvsity's <a style=\"color:#3917b3\" href=\"https://www.uvsity.com/legal/useragreement.html\" target=\"_blank\"><b><font color=#3917b3>terms of service and privacy policy.</font></b></a>" : "By registering you agree to Uvsity's <a style=\"color:#3917b3\" href=\"https://www.uvsity.com/legal/useragreement.html\" target=\"_blank\"><b><font color=#3917b3>terms of service and privacy policy.</font></b></a>",
            header: 'Confirmation Required',
            icon: 'fa fa-question-circle',
            accept: function () {
                _this.showSpinner = true;
                _this.dashboardService.registerCourseFree(id).subscribe(function (data) {
                    _this.showSpinner = false;
                    console.log(data);
                    if (data.errorMsg == null) {
                        _this.freeRegisterSuccessful();
                    }
                    else {
                        _this.createInfoAlert(data.errorMsg);
                    }
                }, function (error) {
                    _this.showSpinner = false;
                    _this.handleError(error);
                });
            },
            reject: function () {
                _this.showSpinner = false;
                console.log("User cancelled registration");
                _this.createInfoAlert("You have chosen not to signup for the session.");
            }
        });
    };
    ViewcourseComponent.prototype.freeRegisterSuccessful = function () {
        //this.showSpinner = false;
        this.registerFromLogin = false;
        var encodedCourseName = btoa(this.courseDetail.courseFullName);
        // this.confirmationService.confirm({
        //   message: "You have successfully registered for the session. You will now be taken to your session enrollment page.",
        //   header: 'Confirmation',
        //   icon: 'fa fa-question-circle',
        //   rejectVisible: false,
        //   accept: () => {
        //   }
        // });
        this.router.navigate(['dashboard/myenrollment'], { queryParams: { success: encodedCourseName } });
    };
    ViewcourseComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    ViewcourseComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    return ViewcourseComponent;
}());
export { ViewcourseComponent };
//# sourceMappingURL=viewcourse.component.js.map